<template>
  <simple-page>
    <template v-slot:pageItem>
      <breadcrumb :items="breadcrumbItems" />
      <pending-items-internal :title="false" />
    </template>
    <template v-slot:pageTitle>
      <div class="d-flex justify-content-between gap-3 align-items-center flex-grow-1 flex-wrap">
        <h1 class="text-upper-case m-0">Plan Change Eligible</h1>
        <div class="btn-planswitch-btn">
          <a href="/plan-switch-history" class="univ-btn m-0 px-3 d-flex align-items-center justify-content-center gap-1">
            <span class="icon-wrapper">
              <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 24 24"><path fill="currentColor" d="M12 21q-3.45 0-6.012-2.287T3.05 13H5.1q.35 2.6 2.313 4.3T12 19q2.925 0 4.963-2.037T19 12t-2.037-4.962T12 5q-1.725 0-3.225.8T6.25 8H9v2H3V4h2v2.35q1.275-1.6 3.113-2.475T12 3q1.875 0 3.513.713t2.85 1.924t1.925 2.85T21 12t-.712 3.513t-1.925 2.85t-2.85 1.925T12 21m2.8-4.8L11 12.4V7h2v4.6l3.2 3.2z"/></svg>
            </span>
            View Plan Switch History
          </a>
        </div>
      </div>
    </template>
    <template v-slot:filter>
      <pending-renewals-filter :filters="filterQuery" @onSearch="filterData" />
    </template>
    <template v-slot:topPagination>
      <div
          class="top-pagination"
      >
        <pagination :rows.sync="rows" :filters="filterQuery" />
      </div>
    </template>
    <template v-slot:table>
      <clients-data :memberLists="rows"  :planSwitch="true"/>
      <pagination :rows.sync="rows" :filters="filterQuery" />
    </template>
  </simple-page>
</template>
<script>
import Api from "@/resource/Api";
import Helper from "@/resource/Helper";
import ClientsData from "@/views/MemberList/partials/ClientsData.vue";
import PendingItemsInternal from "../Dashboard/partials/PendingItemsInternal.vue";
import PendingRenewalsFilter from "./partials/PendingRenewalsFilter";
import EventBus from "../../main";
export default {
  components: { PendingItemsInternal, PendingRenewalsFilter, ClientsData },
  name: "planSwitchEligible",
  data: () => ({
    rows: [],
    columns: [
      { label: "System Id" },
      { label: "Name" },
      { label: "Dates" },
      { label: "Rep & Employee" },
      { label: "Premiums" },
      { label: "Actions" },
    ],
    filterQuery: {
      plan_switch:1,
      first_name: "",
      last_name: "",
      agent_code: "",
      status: "",
      enrollment_date: "",
      state: "",
      effective_date: "",
      enrollment_from: "",
      enrollment_to: "",
      group_id: "",
      rep_id: "",
      // page_size: 30,
    },
    breadcrumbItems: [{ title: "Plan Change Eligible", active: true }],
  }),
  methods: {
    clearFilter() {
      this.filterQuery = {
        plan_switch: 1,
        first_name: "",
        last_name: "",
        agent_code: "",
        status: "",
        enrollment_date: "",
        state: "",
        effective_date: "",
        enrollment_from: "",
        enrollment_to: "",
        group_id: "",
        rep_id: "",
      };
      this.getPendingSignatures();
    },
    filterData(filters) {
      this.filterQuery = filters;
      this.getPendingSignatures(this.filterQuery);
    },
    getPendingSignatures(filters = null) {
      let url;
      let loader = this.$loading.show();

      if (filters) {
        let filterUrl = Helper.objToUrlParams(filters);
        url = `v2/get-members?plan_switch=1&${filterUrl}`;
      } else {
        url = `v2/get-members?plan_switch=1&page_size=10`;
      }

      Api.get(url)
          .then((res) => {
            console.log(res)
            this.rows = res.data;
          })
          .catch(() => {
            this.rows = [];
          })
          .finally(() => {
            loader.hide();
          });
    },
  },
  created() {
    this.getPendingSignatures();
    EventBus.$on("reloadRenewListing", this.getPendingSignatures);
  },
};
</script>
<style src="@/assets/css/viewclients.css"></style>
